import Modal from '/components/ui/Modal';
import Heading from '/components/ui/typography/Heading';
import Paragraph from '/components/ui/typography/Paragraph';
import Button from '/components/ui/buttons/Button';

interface Props {
    onClose: () => void;
}
export default function MissingImagesModal({ onClose }: Props) {
    return (
        <Modal className="p-32" closeRequestCallback={onClose}>
            <Heading size="small" className="mb-24">
                Vennligst last opp bilde
            </Heading>
            <Paragraph className="mb-24">
                Du må laste opp bilder som er etterspurt for å kunne legge
                jobben i handlekurven og fullføre din bestillingen.
            </Paragraph>
            <Button variant="tertiary" size="small" onClick={onClose}>
                Ok
            </Button>
        </Modal>
    );
}
